import {DEFAULT_TEXT_LIST, INPUT_TYPE} from './constants';

export const createDefaultContent = () => {
  return {
    parameter_value: '',
    parameter_type: INPUT_TYPE.TEXT,
    parameter_is_list: false,
    parameter_value_options: DEFAULT_TEXT_LIST,
  }
};
